import { useState } from 'react'
import { Stack, TextField } from '@mui/material';
import { Leg } from '@aviation/cabinapp-flightservice-sdk';
import { DateRangePicker, DateRange, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import FindFlightDialogGrid from './FindFlightDialogGrid';
import dayjs, { Dayjs } from 'dayjs';
import { Message } from '@aviation/cabinapp-message-service-sdk';


export interface ICreateDelayCommEventFlightsProps {
    item: Message;
    validationExecuted: (item: Message, valid: boolean) => void;
}

export function CreateDelayCommEventFlights(props: ICreateDelayCommEventFlightsProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [displayAllFlights, setDisplayAllFlights] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [selectedFlights, setSelectedFlights] = useState<Leg[] | undefined>(undefined);
    const [dateRange, setDateRange] = useState<DateRange<Dayjs>>([dayjs(props.item.EventDate) ?? dayjs(), dayjs(props.item.EventDate).add(1, 'day') ?? dayjs().add(1, 'day')]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hasFlights, setHasFlights] = useState(false);
    const [filterTerm, setFilterTerm] = useState('');

    const onFlightSelected = (list: Leg[]) => {
        setHasFlights(list.length > 0);
        setSelectedFlights(list);

        let flight = list.find(o => o !== undefined);

        if(flight !== undefined) {
            props.item.Conditions = [ { Operator: 'AND', Conditions: [ { Operator: 'CON', Type: 'IdpsId', Value: String(flight.FlightID)}]}];
            props.item.Attributes = [
                { AttrName: 'DepDate', AttrValue: flight.DepDate, AttrValueOld: flight.DepDate },
                { AttrName: 'ArrDate', AttrValue: flight.ArrDate, AttrValueOld: flight.ArrDate },
                { AttrName: 'Dep', AttrValue: flight.Dep, AttrValueOld: flight.Dep },
                { AttrName: 'Dest', AttrValue: flight.Dest, AttrValueOld: flight.Dest }
            ];

            if(props.item.Category === 'NextInfo') {
                props.item.Attributes?.push({ AttrName: 'NextInfo', AttrValue: flight.DepDate, AttrValueOld: undefined });
            }
            props.item.Title = `${flight.Al}${flight.No} | ${flight.Dep} - ${flight.Dest}`;
            props.item.EventDate = flight.FlightDate ?? flight.DepDate;
        }

        props.validationExecuted(props.item, list.length > 0);
    }

    return (
        <Stack direction='column' spacing={2} style={{ padding: 20 }}>
            <Stack direction='row' useFlexGap flexWrap="wrap" spacing={1}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de'>
                    <DateRangePicker value={dateRange} onChange={setDateRange} slotProps={{ textField: { size: 'small' } }} />
                </LocalizationProvider>
                <TextField size='small' id="filterTerm" label="Filter" variant="outlined" onChange={(e) => setFilterTerm(e.target.value)} />
            </Stack>
            <FindFlightDialogGrid filterTerm={filterTerm} airlineList={undefined} dateFrom={dateRange[0]?.format("YYYY-MM-DD") ?? ''} dateTo={dateRange[1]?.format("YYYY-MM-DD") ?? ''} selectionChanged={onFlightSelected} initialSelection={undefined} />
        </Stack>
    )
}

export default CreateDelayCommEventFlights;